<!-- LOADER -->
@if (loading) {
  <app-main-loader-lottie></app-main-loader-lottie>
}

<!-- Main Content -->
@if (isLoadedInitialData) {
  <div>
    <!-- Default Fulfillment View -->
    @if (!isCustomFulfillmentViewEnabled) {
      <!-- INTERACTIONS -->
      <app-scan-modals-container></app-scan-modals-container>
      @if (showHistory) {
        <fulfill-batch-history-modal [parent]="this" (onClose)="showHistory = false"> </fulfill-batch-history-modal>
      }
      <!-- END INTERACTIONS -->
      <fulfill-header></fulfill-header>
      <section [style.--header-height]="layoutService.headerHeight$() + 'px'">
        <h2>Batch List</h2>
        <article>
          <fulfill-side-panel></fulfill-side-panel>
          @if (fulfillService.usePaginatedFulfillment()) {
            <fulfill-batch-list-v2 [pdqUsersList]="pdqUsersList" [batches]="batches" [columns]="columns">
            </fulfill-batch-list-v2>
          } @else {
            <fulfill-batch-list></fulfill-batch-list>
          }
        </article>
        @if (!usePaginatedFulfillment()) {
          <div class="show-history">
            <p (click)="showHistory = true" #toggle>View batch history</p>
          </div>
        }
      </section>
    } @else {
      <div class="custom-fulfillment-view">
        <h2>Fulfill orders</h2>
      </div>
      <div class="custom-fulfillment-view-content">
        <fulfill-side-panel-scan label="Scan an order to print label"></fulfill-side-panel-scan>
      </div>
    }
    <!-- Custom Fulfillment View -->
  </div>
}

<!-- Skeleton Page -->
@if (!isLoadedInitialData) {
  <ng-container *ngTemplateOutlet="skeletonPage"></ng-container>
}

<ng-template #skeletonPage>
  <skeleton-fulfill-page></skeleton-fulfill-page>
</ng-template>
